export const getAll = state => state.toJS();

export const getReservationId = state => state.get('reservationId');

export const getPassengerId = state => state.get('passengerId');



// WEBPACK FOOTER //
// ./src/redux/selectors/GeneralSelectors.js